<template>
    <div class="dashboard-presentation-video h-100">
        <video width="100%" height="100%" autoPlay loop :muted="screen.options.soundMuted">
            <source :src="videoUrl" type="video/mp4" />
        </video>
    </div>
</template>

<script>
    export default {
        name: "DashboardPresentationVideo",

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },

        computed: {
            videoUrl() {
                if(this.screen.options && this.screen.options.videoUrl) {
                    return this.screen.options.videoUrl;
                }
                return "https://player.vimeo.com/external/344279490.hd.mp4?s=103b05ba9500717b1a4f1a27d52cddcd57158f4e&profile_id=175";
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-presentation-video {
        background-color: black;
    }
</style>
